import { useEffect, useState } from "react";
import "./confirm-account.css";
import { CustomModal } from "../components/custom-modal";
import { ROUTES, BASE_URL } from "../assets/constant";
import { useNavigate } from "react-router-dom";
import axios from "axios";
export const ConfirmAccount = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(ROUTES.LOGIN);
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const res = await axios.post(`${BASE_URL}/users/confirm-account`, {
          token: window.location.pathname.split("/").pop()
        });

        setMessage(res?.data?.message || "Account confirmed successfully");
      } catch (error) {
        setMessage(error.response.data.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="confirm-account-page">
      <CustomModal
        isOpen={true}
        btnName={"OK"}
        heading={"Account Confirmation"}
        text={`${loading ? "Loading..." : message}`}
        onClick={handleRedirect}
        closeModal={handleRedirect}
      />
    </div>
  );
};
